// Client-safe promotion utilities
// This file can be imported in client components without database dependencies.
// All pricing/credit numbers are re-exported from `./pack-config`, the single
// source of truth also used by the server-side `@/lib/payments` module, so
// the two can never drift out of sync again.

import {
  getPackBaseCredits,
  getPackEffectiveCredits,
  getPackName as getSharedPackName,
  getPackPriceUsd as getSharedPackPriceUsd,
  isPackPromotionEnabled,
  type CreditPackId,
} from "./pack-config";

export type { CreditPackId };

// Configuration: Which pack to use as the default CTA on the preview screen
// Change this value to promote a different pack (e.g., "pro", "power", "basic")
export const PREVIEW_CTA_PACK_ID: CreditPackId = "basic";

// Check if promotion is enabled for a pack (client-safe)
export function isPromotionEnabled(packId: CreditPackId): boolean {
  return isPackPromotionEnabled(packId);
}

// Get effective credits for a pack (client-safe)
export function getEffectiveCredits(packId: CreditPackId): number {
  return getPackEffectiveCredits(packId);
}

// Get non-promotional base credits for a pack (client-safe)
export function getBaseCredits(packId: CreditPackId): number {
  return getPackBaseCredits(packId);
}

// Get pack name (client-safe)
export function getPackName(packId: CreditPackId): string {
  return getSharedPackName(packId);
}

// Get pack price in USD (client-safe)
export function getPackPriceUsd(packId: CreditPackId): number {
  return getSharedPackPriceUsd(packId);
}
